import { createTheme } from '@mui/material'
import { DefaultTheme } from 'styled-components'
import { GuigoLight } from '../Guigotv'

const theme: DefaultTheme = createTheme({
  ...GuigoLight,
  backgroundColor: '#fafafa',
  textColor: '#202020',
  imgSideBar: '/guigo-logo.png',
  imgForm: '/LogoProviders/turbolink.png',
  palette: {
    mode: 'light',
  },
  typography: {
    allVariants: {
      fontSize: '1.2rem',
    },
    h3: {
      padding: '10px',
    },
    fontSize: 16,
  },
  colors: {
    primary: { main: '#c8102d', hover: '#c8102d' },
    secondary: { main: '#3E237F', hover: '#3E237F' },
    ternary: { main: '#f5f5f5', hover: '#f5f5f5' },
  },
})

export default theme
